import axios from 'axios'
import { ResponseAPIWithPagination } from '../../../common/types/API.types'
import { MeterTagEntity } from '../types/meterTag.types'

const BACKEND_URL = process.env.REACT_APP_BACKEND_API_URL + '/api/v1'

const BASE = `${BACKEND_URL}/meter-tags`

export const getMeterTagsBulk = async (
  productNumbers: string[],
): Promise<MeterTagEntity[]> => {
  if (productNumbers.length === 0) return []
  const params = new URLSearchParams({
    currentPage: '0',
    pageSize: '500',
    product_numbers: productNumbers.join(','),
  })
  const res = await axios.get<ResponseAPIWithPagination<MeterTagEntity>>(
    `${BASE}?${params.toString()}`,
  )
  return res.data.data ?? []
}

export const getAllMeterTags = async (): Promise<MeterTagEntity[]> => {
  const params = new URLSearchParams({
    currentPage: '1',
    pageSize: '5000',
  })
  const res = await axios.get<ResponseAPIWithPagination<MeterTagEntity>>(
    `${BASE}?${params.toString()}`,
  )
  return res.data.data ?? []
}

export const getMeterTagsByTags = async (tags: string[]): Promise<MeterTagEntity[]> => {
  if (tags.length === 0) return []
  const params = new URLSearchParams({
    currentPage: '0',
    pageSize: '500',
    tags: tags.join(','),
  })
  const res = await axios.get<ResponseAPIWithPagination<MeterTagEntity>>(
    `${BASE}?${params.toString()}`,
  )
  return res.data.data ?? []
}

export const getMeterTag = async (productNumber: string): Promise<MeterTagEntity | null> => {
  try {
    const res = await axios.get<MeterTagEntity>(`${BASE}/${encodeURIComponent(productNumber)}`)
    return res.data
  } catch (err: any) {
    if (err?.response?.status === 404) return null
    throw err
  }
}

export const upsertMeterTag = async (
  productNumber: string,
  tags: string[],
): Promise<MeterTagEntity> => {
  const body: MeterTagEntity = { product_number: productNumber, tags }
  const res = await axios.put<MeterTagEntity>(
    `${BASE}/${encodeURIComponent(productNumber)}`,
    body,
  )
  return res.data
}

export const deleteMeterTag = async (productNumber: string): Promise<void> => {
  await axios.delete(`${BASE}/${encodeURIComponent(productNumber)}`)
}

const meterTagAPI = {
  getMeterTagsBulk,
  getAllMeterTags,
  getMeterTagsByTags,
  getMeterTag,
  upsertMeterTag,
  deleteMeterTag,
}

export default meterTagAPI
